import { render, staticRenderFns } from "./ProjectGuestsInviteNew.vue?vue&type=template&id=856ec7e6&scoped=true"
import script from "./ProjectGuestsInviteNew.vue?vue&type=script&lang=ts"
export * from "./ProjectGuestsInviteNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectGuestsInviteNew.vue?vue&type=style&index=0&id=856ec7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856ec7e6",
  null
  
)

export default component.exports